module.exports = __webpack_public_path__ + "img/indiju_mimedicamento.782b963b.png";